var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrop916(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9:16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 0.5,
    width: 17,
    height: 31,
    rx: 3.5,
    ry: 3.5,
    stroke: "#1f2830"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 17.11c.28.29.59.46 1.1.46.97 0 1.41-.88 1.41-1.75v-.16c-.25.36-.81.75-1.43.75-.96 0-1.79-.59-1.79-1.73 0-.98.78-1.79 1.97-1.79 1.57 0 2.2 1.27 2.2 2.76s-.81 2.75-2.35 2.75c-.66 0-1.17-.23-1.53-.59l.43-.7Zm1.3-3.38c-.7 0-1.06.5-1.06.93 0 .66.51.95 1.09.95.46 0 .9-.24 1.17-.62-.05-.58-.37-1.26-1.19-1.26ZM14.51 14.4c.3 0 .56.26.56.56s-.26.56-.56.56-.56-.26-.56-.56.26-.56.56-.56Zm0 2.89c.3 0 .56.26.56.56s-.26.56-.56.56-.56-.26-.56-.56.26-.56.56-.56ZM17.03 14.2l-.87.9-.54-.57 1.53-1.55h.82v5.33h-.94v-4.12ZM21.21 12.91c.66 0 1.17.24 1.54.59l-.44.71c-.28-.3-.58-.47-1.1-.47-.89 0-1.41.82-1.41 1.76v.15c.24-.36.8-.74 1.43-.74.96 0 1.78.58 1.78 1.72 0 .99-.78 1.79-1.97 1.79-1.57 0-2.2-1.27-2.2-2.75s.81-2.76 2.35-2.76Zm-.22 2.8c-.46 0-.9.25-1.17.63.06.58.37 1.25 1.19 1.25.7 0 1.07-.5 1.07-.93 0-.66-.51-.95-1.09-.95Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop916);
export default __webpack_public_path__ + "static/media/crop-9-16.1a729d365cd564d154e68693326cfbab.svg";
export { ForwardRef as ReactComponent };